export default __webpack_public_path__ + "static/best2024-dca10e1c4d3d6a54037ed32c204f8640.jpeg";